import { useParams } from "react-router-dom";
import { useChallengeSubscriberAthleteList } from "../../api/challenges/queryHooks";
import { decodeId, get_media_url } from "../../api/utils";

const MemberPositionLoading = () => {
  return (
    <div className="h-[50px] border-b last:border-b-0 border-[#37383C] flex items-center px-2">
      <div className="w-[30px] flex items-center justify-center">
        <span className="text-xs bg-[#454755] px-[7px] py-[3px] rounded-2xl h-3 skeleton"></span>
      </div>
      <div className="w-[30px] h-[30px] ml-3 rounded-full border border-[#37383C]">
        <div className="w-full h-full rounded-full skeleton" />
      </div>
      <div className="ml-[10px] flex-grow">
        <span className="w-[120px] h-[14px] skeleton rounded-md"></span>
      </div>
      <div className="mx-2 w-[38px] bg-[#FFBFDC] text-[#FF0074] text-center px-[7px] py-[5px] rounded-2xl text-[11px] h-4 skeleton"></div>
    </div>
  );
};

const MemberPosition = ({ data }) => {
  return (
    <div className="h-[50px] border-b last:border-b-0 border-[#37383C] flex items-center px-2">
      <div className="w-[30px] flex items-center justify-center">
        <span className="text-xs bg-[#454755] px-[7px] py-[3px] rounded-2xl">
          {data.current_position}
        </span>
      </div>
      <div className="w-[30px] h-[30px] ml-3 rounded-full border border-[#37383C]">
        <img
          loading="lazy"
          className="w-full h-full rounded-full"
          src={get_media_url(data.profile_dp)}
          alt={data.full_name}
        />
      </div>
      <div className="ml-[10px] text-[14px] flex-grow">{data.full_name}</div>
      <div className="mx-2 w-[38px] bg-[#FFBFDC] text-[#FF0074] text-center px-[7px] py-[5px] rounded-2xl text-[11px]">
        {data.current_score}
      </div>
    </div>
  );
};

export const MemberLastPosition = ({ data, className }) => {
  return (
    <div
      className={`h-[56px] flex items-center rounded-2xl bg-[#FE0677] px-2 ${
        className ?? ""
      }`}
    >
      <div className="w-[30px] flex items-center justify-center">
        <span className="text-xs text-[#FE0677] bg-[#FFFFFF] px-[7px] py-[3px] rounded-2xl">
          {data.position}
        </span>
      </div>
      <div className="w-[30px] h-[30px] ml-3 rounded-full border border-[#37383C]">
        <img
          loading="lazy"
          className="w-full h-full rounded-full"
          src={data.photo}
          alt={data.name}
        />
      </div>
      <div className="ml-[10px] text-[14px] flex-grow">{data.name}</div>
      <div className="mx-2 w-[38px] text-center px-[7px] py-[5px] rounded-2xl text-[11px]">
        {data.points}
      </div>
    </div>
  );
};

const MemberPositionList = () => {
  const id = decodeId(useParams()?.id);

  const { data, isLoading, isError } = useChallengeSubscriberAthleteList(
    id,
    1,
    100
  );

  if (isError) return null;

  return (
    <div>
      <div className="lg:sticky lg:top-[68px]">
        <div className="hidden lg:block pr-5">
          <h3 className="text-[17px]">Position</h3>
          <div className="border-b-2 border-[#2C2D36] mt-1 mb-2"></div>
        </div>
        {/* <div className="px-5 mt-14 lg:mt-0 lg:max-h-[calc(100vh-178px)] lg:overflow-y-auto lg:pl-0 hide-scrollbar"> */}
        <div className="px-5 mt-14 lg:mt-0 lg:max-h-[calc(100vh-110px)] lg:overflow-y-auto lg:pl-0 hide-scrollbar">
          <ul className="bg-[#2C2D36] rounded-2xl">
            {isLoading
              ? Array.from({ length: 24 }).map((item, index) => (
                  <MemberPositionLoading key={index} />
                ))
              : data.data.data.map((item, index) => (
                  <MemberPosition key={index} data={item} />
                ))}
          </ul>
        </div>
        {/* <div className="lg:pr-4 lg:mt-2">
          <MemberLastPosition
            data={data[data.length - 1]}
            className="fixed bottom-2 left-1/2 w-[calc(100vw-40px)] max-w-[1320px] -translate-x-1/2 lg:translate-x-0 lg:static lg:w-full"
          />
        </div> */}
      </div>
    </div>
  );
};

export default MemberPositionList;
